import React from "react";

const TabSelector = ({ tabs = [], activeTab, onTabChange }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "28px",
        borderBottom: "1px solid #ddd",
        marginBottom: "10px",
        marginTop: "10px"
      }}
    >
      {tabs.map(tab => {
        const isActive = activeTab === tab.key;
        return (
          <div
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            style={{
              cursor: "pointer",
              fontFamily: "Roboto",
              fontSize: "16px",
              fontWeight: 400,
              color: isActive ? "#3B5998" : "#4D4D4D",
              borderBottom: isActive ? "3px solid #3B5998" : "3px solid transparent",
              paddingBottom: "6px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.3s ease",
              paddingLeft: "10px",
              paddingRight: "10px"
            }}
          >
            {tab.icon && tab.icon(isActive)}
            <span>{tab.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default TabSelector;